// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n}\n\n.emoji-mart-scroll + .emoji-mart-bar {\n  display: none;\n  pointer-events: none;\n}\n\n.add-more {\n  display: none !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
